import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/case-studies/mdrouz/highlights.png";
import Img2 from "../../../images/case-studies/mdrouz/high_img.png";
import BgImg1 from "../../../images/case-studies/mdrouz/flower.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Highlightscase = () => {
    return (
        <div className="highlight_case p-100" style={{ backgroundImage: `url(${BgImg1})` }}>
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={4} xxl={4} className="my-auto">
                        <div className="high_head">
                            <h2><span>Highlights</span></h2>
                            <p>Mdrouz stands out with its key features, including the ability to shop from a variety of stores, secure and convenient payment options through Upayment, product like count for popularity insights, personalized recommendations for users, fast and reliable delivery services, a user-friendly interface, advanced search and filters, and multi-currency support.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={7} xl={8} xxl={8} className="my-auto">
                        <div className="high_img">
                        <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="TekRevol" className="img-fluid d-none d-lg-block"
                                />
                                 <LazyLoadImage
                                    src={Img2}
                                    effect="blur" alt="TekRevol" className="img-fluid d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none"
                                />
                        </div>
                    </Col>
                </Row>
            </Container>
            </div>
    )
}

export default Highlightscase